import UndoIcon from '@mui/icons-material/UndoRounded';
import { LexicalEditor, UNDO_COMMAND } from 'lexical';
import { StyledButton } from '../../styles';
import { IS_APPLE } from '../../../../shared/environment';

interface Props {
  canUndo: boolean;
  isEditable: boolean;
  activeEditor: LexicalEditor;
}

export default function UndoButton(props: Props) {
  const { canUndo, isEditable, activeEditor } = props;
  return (
    <StyledButton
      disabled={!canUndo || !isEditable}
      onClick={() => {
        activeEditor.dispatchCommand(UNDO_COMMAND, undefined);
      }}
      title={IS_APPLE ? 'Undo (⌘Z)' : 'Undo (Ctrl+Z)'}
      type="button"
      className="toolbar-item spaced"
      aria-label="Undo"
    >
      <UndoIcon />
    </StyledButton>
  );
}
